import React from "react";
import Col from "react-bootstrap/Col";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import "./LineChart.css";

function LineChart({ data }) {
  const { t } = useTranslation();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        // Configuration for the y-axis (vertical)
        min: 0, // Set the minimum value of the scale
        max: 100, // Set the maximum value of the scale
        ticks: {
          // Include a specific step size for tick marks (optional)
          stepSize: 10,
        },
      },
      x: {
        // Configuration for the x-axis (horizontal)
        // You can add configurations for the x-axis here as well
      },
    },
  };

  return (
    <Col className="comparison-chart-container">
      <Line data={data} options={options} />
    </Col>
  );
}

export default LineChart;
